import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageContentSections } from "../components/CMS/Sections/ManageContentSections";

export const ContentSectionsManage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageContentSections />
        </div>
      </div>
    </div>
  );
};
